export default __webpack_public_path__ + "static/media/1205.8004874c.png";